/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector, useDispatch } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { Link } from 'react-router-dom'
import { baseUrl } from "../../../../../services/config";
export function UserProfileDropdown() {


  const dispatch = useDispatch()
  const history = useHistory()

  const { user } = useSelector((state) => state.auth);
  const uiService = useHtmlClassService();
  const authToken = localStorage.getItem("userToken");

  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);



  const logoutUser = () => {
    localStorage.clear();
    dispatch({
      type: "ADD_USER",
      payload: {
        isAuthenticated: false,
        authtoken: null,
        user: null,
      },
    });
    history.push("/auth/login");
    // fetch(`${baseUrl}/logout`, {
    //   method: "POST", headers: {
    //     Authorization: `Bearer ${authToken}`,
    //   }
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     if (data.metadata.success) {
    //       console.error("Error Logging Out");
    //       localStorage.clear();
    //       dispatch({
    //         type: "ADD_USER",
    //         payload: {
    //           isAuthenticated: false,
    //           authtoken: null,
    //           user: null,
    //         },
    //       });
    //       history.push("/auth/login");

    //     }
    //   })
    //   .catch((err) => console.error(err))

  }




  return (
    <Dropdown drop="down" alignRight>
      {/* <div className="navi-footer  px-8 py-5">
        <button
          onClick={() => logoutUser()}
          className="btn btn-light-danger font-weight-bold"
        >
          Sign Out
        </button>
      </div> */}
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
          }
        >
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
            Hi,
          </span>{" "}
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"></span>
          <span className="symbol symbol-35 symbol-light-success">
            <span className="symbol-label font-size-h5 font-weight-bold"></span>
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <>
          {layoutProps.light && (
            <>
              <div className="d-flex align-items-center p-8 rounded-top">
                <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                  <img src={toAbsoluteUrl("/media/users/300_21.jpg")} alt="" />
                </div>
                <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5"></div>
                <span className="label label-light-success label-lg font-weight-bold label-inline">
                  3 messages
                </span>
              </div>
              <div className="separator separator-solid"></div>
            </>
          )}

          {/* {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/misc/bg-1.jpg"
                )})`,
              }}
            >
              <div className="symbol bg-white-o-15 mr-3">
                <span className="symbol-label text-success font-weight-bold font-size-h4"></span>
                <img alt="Pic" className="hidden" src={user.pic} />
              </div>
              <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5"></div>
              <span className="label label-success label-lg font-weight-bold label-inline">
                3 messages
              </span>
            </div>
          )} */}
        </>

        <div className="navi navi-spacer-x-0 pt-5">
          <Link to="/change-password" className="navi-item px-8 cursor-pointer">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-calendar-3 text-success" />
              </div>
              <div className="navi-text">
                <div className="font-weight-bold cursor-pointer">
                  Change Password
                </div>

              </div>
            </div>
          </Link>

          {/* <a className="navi-item px-8">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-mail text-warning"></i>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">My Messages</div>
                <div className="text-muted">Inbox and tasks</div>
              </div>
            </div>
          </a>

          <a className="navi-item px-8">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-rocket-1 text-danger"></i>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">My Activities</div>
                <div className="text-muted">Logs and notifications</div>
              </div>
            </div>
          </a> */}

          <a
            onClick={logoutUser}
            className="navi-item px-8">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-hourglass text-danger"></i>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">Signout</div>
              </div>
            </div>
          </a>
          <div className="navi-separator mt-3"></div>


        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
